import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banner-wrap"
}
const _hoisted_2 = {
  key: 1,
  class: "outer-container"
}
const _hoisted_3 = { class: "header-inner" }
const _hoisted_4 = {
  key: 0,
  class: "separator"
}

import { useRoute, RouteLocationNormalized } from 'vue-router';
import { reactive, ref, computed } from 'vue';
import Banner from '@/components/web/Banner.vue';
import { usePageData } from '@/composables/usePageData'
import { useI18n } from 'vue-i18n';

type BreadcrumbItem = {
    text: string;
    to?: string;
    key?: string;
}

// 本地状态存储面包屑数据

export default /*@__PURE__*/_defineComponent({
  __name: 'bannerBread',
  props: {
    bannerImages: {},
    bannerHeight: { default: 550 },
    breadcrumbItems: {},
    isBannerBread: { type: Boolean, default: true }
  },
  setup(__props: any) {

const { t } = useI18n();

// 定义面包屑项目的数据结构
const localBreadcrumbItems = ref<BreadcrumbItem[]>([
    { text: 'Home', to: '/' }
]);

const props = __props

const route = useRoute();
const isHovered = ref(false);

// 添加默认值处理
const formatTitle = (text: string) => {
    if (!text) return '';
    // 移除 breadcrumb. 前缀
    const title = text.replace('breadcrumb.', '');

    // 处理连字符格式
    return title
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

// 将文本转换为翻译 key
const textToKey = (text: string): string => {
    if (!text) return '';
    return text.toLowerCase()
        .split(' ')
        .map((word, index) =>
            index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
};

// 处理面包屑数据
const processedBreadcrumbItems = computed(() => {
    const items = localBreadcrumbItems.value;
    return items.map(item => ({
        ...item,
        // 使用 text 生成标准化的 key
        key: item.key || textToKey(item.text)
    }));
});
const toKebabCase = (str: string): string => {
    if (str === "Home") {
        return "/";
    }
    return str
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '');
};

const updateBreadcrumb = (route: RouteLocationNormalized) => {
    const breadcrumb: BreadcrumbItem[] = [];

    if (!route || !Array.isArray(route.matched)) {
        console.error('route or route.matched is undefined or not an array');
        return;
    }

    route.matched.forEach((routeRecord) => {
        let breadcrumbText: string[] = (Array.isArray(routeRecord.meta?.breadcrumb)
            ? routeRecord.meta?.breadcrumb
            : [routeRecord.name ?? '默认面包屑']);


        // 检查路由路径是否包含动态参数
        if (routeRecord.path.includes(':title')) {
            const pathParts = route.path.split('/');
            const title = pathParts[pathParts.length - 1];
            breadcrumbText = [...breadcrumbText, title];  // 直接使用原始标题
        }


        breadcrumbText.forEach((text) => {
            breadcrumb.push({
                text: text,
                to: toKebabCase(text)
            });
        });
    });

    // 更新本地状态
    localBreadcrumbItems.value = breadcrumb;
}

const populateBreadcrumb = () => {
    updateBreadcrumb(route);
}

usePageData(populateBreadcrumb);

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isBannerBread)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Banner, {
            "banner-images": _ctx.bannerImages,
            hover: isHovered.value,
            "-banner-height": _ctx.bannerHeight
          }, null, 8, ["banner-images", "hover", "-banner-height"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isBannerBread)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_breadcrumb, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedBreadcrumbItems.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                    key: index,
                    to: { path: item.to }
                  }, {
                    default: _withCtx(() => [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/"))
                        : _createCommentVNode("", true),
                      (index === processedBreadcrumbItems.value.length - 1 && _unref(route)?.params?.title)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(formatTitle(item.text)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_unref(t)(`breadcrumb.${item.key}`)), 1)
                          ], 64))
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})